export default __webpack_public_path__ + "static/media/perfil.400f97a1.png";